module.exports = __webpack_public_path__ + "static/series_ht-8a880cf5ee3b9f20cd48c0f0e6838762.png";